import { render, staticRenderFns } from "./commonWords.vue?vue&type=template&id=054d4a47"
import script from "./commonWords.vue?vue&type=script&lang=js"
export * from "./commonWords.vue?vue&type=script&lang=js"
import style0 from "./commonWords.vue?vue&type=style&index=0&id=054d4a47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports